import script from "./FormVueSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./FormVueSelect.vue?vue&type=script&setup=true&lang=js"

import "./FormVueSelect.vue?vue&type=style&index=0&id=67f27df3&lang=css"

const __exports__ = script;

export default __exports__